/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{ useState,useEffect } from "react";
import axios from 'axios';

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";
import {LoginAfterCheckLogin,isNull} from "../../components/common/Common";

import "../../css/style.css";

const AppSetting = () => {
  LoginAfterCheckLogin(1);  //로그인 상태 점검
  const mem_idx = Number(localStorage.getItem("mem_idx"));

  const [varAlertDriving,setAlertDriving] = useState(0);

  const getAlarmSetting = async () => {
    const sendData = {mem_idx:mem_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_alam_state`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const alams = datas.results;
        setAlertDriving(alams.mem_alert_driving);
      }
    });
  }
  //최초실행부
  useEffect(() => {
    getAlarmSetting();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeCheckBoxHandler = async(e) => {
    const { name } = e.currentTarget;
    const imode = Number(e.currentTarget.checked);
    setAlertDriving(imode);

    //데이타베이스에 저장
    const sendData = {mem_idx:mem_idx,fieldName:name,fieldValue:imode};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_setup_alam_state`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      console.log(datas.message);
    });
  }

  return isNull(varAlertDriving)?null: (
    <div className="vh-container">
      <Header varGoToMain={true} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'앱 설정'} />
        <div className="vh-content-body">
          <div className="setting-row ms25">
            <label htmlFor="mem_alert_driving">신규 배차 알림</label>
            <div className="switchbox">
              <input type="checkbox" name="mem_alert_driving" id="mem_alert_driving" checked={varAlertDriving} onChange={onChangeCheckBoxHandler}/>
              <label htmlFor="mem_alert_driving"></label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AppSetting;